<template>
	<div class="user-info-mask" @click="onHide">
		<div class="user-info" :style="{ left: pos.x + 'px', top: pos.y + 'px' }" @click.stop>
			<div class="user-info-box">
				<div class="avatar">
					<head-image :name="user.nickName" :url="user.headImage" :size="60" :online="user.online"
						@click.native="showFullImage()" radius="10%"> </head-image>
				</div>
				<div class="info-card">
					<div class="header">
						<div class="nick-name" :class="{ 'official-name': user.userTag == 1 }">{{ user.nickName }}</div>
						<official-tag :user-tag="user.userTag" size="medium"></official-tag>
						<div v-if="user.sex == 0" class="icon iconfont icon-man" style="color: darkblue;"></div>
						<div v-if="user.sex == 1" class="icon iconfont icon-girl" style="color: darkred;"></div>
						<el-tag v-if="user.status == 1" size="mini" type="danger">已注销</el-tag>
						<el-tag v-if="user.isBanned" size="mini" type="danger">已封禁</el-tag>
					</div>
					<div class="info-item" v-if="isFriend">
						用户ID: {{ user.id }}
					</div>
					<div class="info-item">
						个性签名: {{ user.signature || '暂无个性签名' }}
					</div>
				</div>
			</div>
			<el-divider content-position="center"></el-divider>
			<div class="user-btn-group">
				<el-button v-if="isFriend" type="primary" @click="onSendMessage()">发消息</el-button>
				<span class="wait-text" v-else-if="isWaitingApprove">好友验证中</span>
				<el-button v-else-if="isAddFriend" type="primary" @click="onAddFriend()">加为好友</el-button>
				<el-button v-else type="primary" @click="onHide()">取消</el-button>
			</div>
			<friend-apply ref="applyRef"></friend-apply>
		</div>
	</div>


</template>

<script>
import FriendApply from '../friend/FriendApply.vue';
import HeadImage from './HeadImage.vue';
import OfficialTag from './OfficialTag.vue';

export default {
	name: "userInfo",
	components: {
		HeadImage,
		OfficialTag,
		FriendApply
	},
	data() {
		return {

		}
	},
	props: {
		user: {
			type: Object
		},
		pos: {
			type: Object
		}
	},
	methods: {
		onSendMessage() {
			let user = this.user;
			let chat = {
				type: 'PRIVATE',
				targetId: user.id,
				showName: user.nickName,
				headImage: user.headImage,
				userTag: user.userTag,
			};
			this.$store.commit("openChat", {...chat, activeChat: true});
			// this.$store.commit("activeChat", 0);
			if (this.$route.path != "/home/chat") {
				this.$router.push("/home/chat");
			}
			this.$emit("close");
		},
		onAddFriend() {
			this.$refs.applyRef.open(this.user);
		},
		onHide() {
			this.$emit("close");
		},
		showFullImage() {
			if (this.user.headImage) {
				this.$store.commit("showFullImageBox", this.user.headImage);
			}
		}
	},
	computed: {
		isFriend() {
			return this.$store.getters.isFriend(this.user.id);
		},
		isAddFriend() {
			return this.user.isAddFriend;
		},
		isWaitingApprove() {
			return this.$store.getters.isInRecvRequest(this.user.id);
		}
	}
}
</script>

<style lang="scss">
.user-info-mask {
	background-color: rgba($color: #f4f4f4, $alpha: 0);
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 5;
}

.user-info {
	position: absolute;
	width: 300px;
	background-color: white;
	box-shadow: var(--im-box-shadow);
	border-radius: 4px;
	padding: 15px;

	.user-info-box {
		display: flex;
		align-items: center;

		.info-card {
			flex: 1;
			padding-left: 10px;

			.header {
				display: flex;
				align-items: center;
				gap: 4px;

				.nick-name {
					font-size: var(--im-font-size-large);
					font-weight: 600;
				}

				.icon {
					margin-left: 3px;
					font-size: var(--im-font-size);
				}

				.el-tag {
					margin-left: 3px;
				}
			}

			.info-item {
				font-size: var(--im-font-size);
				margin-top: 5px;
				word-break: break-all;

			}
		}

	}

	.el-divider--horizontal {
		margin: 18px 0;
	}

	.user-btn-group {
		text-align: center;

		.wait-text {
			font-size: 14px;
			color: var(--im-text-color-light);
		}
	}
}
</style>
